import Box from "@/common/components/Box";
import ResumeItem from "@/common/components/ResumeItem";
import { useForwardingTabContext } from "@/features/maintenance/features/workflows/hooks/forwardings/useForwardingTabContext";
import TransportAutoEntriesComplete from "./Transport/AutoEntries/Complete";
import MaintenanceWorkflowForwardingCheckinEntryInfoModal from "./InfoModal";
import { formatDateTime } from "@/common/utils/formatters";

interface MaintenanceWorkflowForwardingCheckinEntrySectionProps {
  showTransportAutoEntriesDeliveryCodeWithComplete?: boolean;
}

const MaintenanceWorkflowForwardingCheckinEntrySection = ({
  showTransportAutoEntriesDeliveryCodeWithComplete,
}: MaintenanceWorkflowForwardingCheckinEntrySectionProps) => {
  const { forwarding } = useForwardingTabContext();

  return (
    <Box className="p-4 flex flex-col gap-4">
      <div className="flex items-center justify-between">
        <div className="flex flex-col">
          <p className="text-lg font-semibold">
            Método de check-in
          </p>

          {forwarding?.checkin_entry?.completed_by && (
            <div className="flex items-center gap-1 -my-1">
              <p className="text-valid text-xs">
                Check-in concluído
              </p>
              <MaintenanceWorkflowForwardingCheckinEntryInfoModal
                checkinEntry={forwarding.checkin_entry}
              />
            </div>
          )}
        </div>

        {showTransportAutoEntriesDeliveryCodeWithComplete && (
          <TransportAutoEntriesComplete
            checkinEntry={forwarding.checkin_entry}
          />
        )}
      </div>

      <div className="flex gap-4">
        {forwarding?.checkin_entry?.responsible && !forwarding?.checkin_entry?.completed_by && (
          <ResumeItem
            label="Responsável por Transporte"
            value={forwarding?.checkin_entry?.responsible.full_name || '--'}
            className="text-xs"
            valueClassName="font-bold text-sm"
          />
        )}

        {forwarding?.checkin_entry?.completed_at && (
          <ResumeItem
            label="Check-in realizado"
            value={formatDateTime(new Date(forwarding?.checkin_entry?.completed_at))}
            className="text-xs"
            valueClassName="font-bold text-sm"
          />
        )}

        {forwarding?.checkin_entry?.completed_at && forwarding?.checkin_entry?.completed_by && (
          <ResumeItem
            label="Usuário que realizou o check-in"
            value={forwarding.checkin_entry.completed_by.full_name}
            className="text-xs"
            valueClassName="font-bold text-sm"
          />
        )}
      </div>
    </Box>
  )
}

export default MaintenanceWorkflowForwardingCheckinEntrySection;
